import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-797378b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content has-background-contents shadow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-main" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" オンライン資料1タイトルにつき1件をご入力ください。雑誌のように同じタイトルで複数巻号がある場合は、まとめて入力してください。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 入力いただいた内容は、当館のメタデータ作成ルールに基づき修正する場合があります。当館が作成・公開したメタデータの修正依頼には原則対応しておりませんので、予めご承知おきください。 ")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "contents-form" }
const _hoisted_5 = { class: "area-clear" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "入力をクリア", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title sub-title" }, "オンライン資料に関する項目", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = { class: "contents-form" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = { class: "contents-form" }
const _hoisted_16 = { class: "navigation" }
const _hoisted_17 = { class: "navigation-button" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 戻る ", -1))
const _hoisted_19 = { class: "navigation-button" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navigation-text" }, " 内容を確認 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemForm = _resolveComponent("ItemForm")!
  const _component_UrlForm = _resolveComponent("UrlForm")!
  const _component_CollectInfoForm = _resolveComponent("CollectInfoForm")!
  const _component_PermissionForm = _resolveComponent("PermissionForm")!
  const _component_UserDataForm = _resolveComponent("UserDataForm")!
  const _component_OthersForm = _resolveComponent("OthersForm")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.inputClear && _ctx.inputClear(...args))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.inputClear && _ctx.inputClear(...args)), ["prevent"]), ["space","enter"])),
          class: "button-clear"
        }, _hoisted_7, 32)
      ]),
      _hoisted_8,
      _createVNode(_component_ItemForm, {
        modelValue: _ctx.autoCollectOnlineData,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.autoCollectOnlineData) = $event)),
        requiredCheck: _ctx.requiredCheck
      }, null, 8, ["modelValue", "requiredCheck"]),
      _hoisted_9,
      _createVNode(_component_UrlForm, {
        modelValue: _ctx.autoCollectUrl,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.autoCollectUrl) = $event)),
        requiredCheck: _ctx.requiredCheck
      }, null, 8, ["modelValue", "requiredCheck"]),
      _hoisted_10,
      _createVNode(_component_CollectInfoForm, {
        modelValue: _ctx.regularlyCollect,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.regularlyCollect) = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_11,
      _createVNode(_component_PermissionForm, {
        modelValue: _ctx.permission,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.permission) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_UserDataForm, {
        modelValue: _ctx.autoCollectApplicant,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.autoCollectApplicant) = $event)),
        requiredCheck: _ctx.requiredCheck
      }, null, 8, ["modelValue", "requiredCheck"])
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_OthersForm, {
        modelValue: _ctx.others,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.others) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_AppButton, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.router.push('agreement'))),
          onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('agreement')), ["prevent"]), ["space","enter"])),
          buttonId: 'button-back'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DssIcon, {
              icon: "arrow-left",
              style: {"font-size":"18px"}
            }),
            _hoisted_18
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_AppButton, {
          onClick: _ctx.confirm,
          onKeydown: _withKeys(_withModifiers(_ctx.confirm, ["prevent"]), ["space","enter"]),
          styled: 'is-accent',
          buttonId: 'button-next'
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["onClick", "onKeydown"])
      ])
    ])
  ]))
}